import { objectProto } from './context'
const { propertyIsEnumerable: contextPropertyIsEnumerable } = objectProto
export default contextPropertyIsEnumerable
